export default __webpack_public_path__ + "assets/images/chickenleg-1c727a86af7a3409473091ec0dbf8946.png";